// extracted by mini-css-extract-plugin
export var label = "_id-2";
export var slideContainer = "_id-0";
export var slider = "_id-1";